import React, { useContext } from "react";
import { ScenarioSection } from "../../context/ScenarioContext";
import { useTranslation } from "react-i18next";
const DeviceDetails = () => {
  const { ShowHideFunction } = useContext(ScenarioSection);
  const { t } = useTranslation();
  return (
    <>
      <div style={{ height: "68vh" }}>
        <div className="addScenarioCard mb-3 bg-white d-flex align-items-center px-3 py-3">
          <label className="position-relative deviceCheckbox mr-4">
            <input type="radio" name="onOff" />
            <span class="checkmark rounded-circle"></span>
          </label>
          <div className="text-right mr-3">
            <p className="m-0 fn">{t("روشن")}</p>
          </div>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex align-items-center px-3 py-3">
          <label className="position-relative deviceCheckbox mr-4">
            <input type="radio" name="onOff" />
            <span class="checkmark rounded-circle"></span>
          </label>
          <div className="text-right mr-3">
            <p className="m-0 fn">{t("خاموش")}</p>
          </div>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex align-items-center px-3 py-3 mt-5">
          <div className="text-right">
            <p className="m-0 fn"> {t("قطع صدا")}</p>
          </div>
          <label className="position-relative deviceCheckbox mr-auto">
            <input type="checkbox" />
            <span class="checkmark rounded-circle"></span>
          </label>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex align-items-center px-3 py-3">
          <div className="text-right">
            <p className="m-0 fn"> {t("عوض شدن کانال")}</p>
          </div>
          <label className="position-relative deviceCheckbox mr-auto">
            <input type="checkbox" />
            <span class="checkmark rounded-circle"></span>
          </label>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex align-items-center px-3 py-3">
          <div className="text-right">
            <p className="m-0 fn">{t(" تغییر حالت تصویر")}</p>
          </div>
          <label className="position-relative deviceCheckbox mr-auto">
            <input type="checkbox" />
            <span class="checkmark rounded-circle"></span>
          </label>
        </div>
        <div className="addScenarioCard mb-3 bg-white d-flex align-items-center px-3 py-3">
          <div className="text-right">
            <p className="m-0 fn"> {t("کم زیاد شدن صدا")}</p>
          </div>
          <label className="position-relative deviceCheckbox mr-auto">
            <input type="checkbox" />
            <span class="checkmark rounded-circle"></span>
          </label>
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-center mt-3">
        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={() => ShowHideFunction("firstPage")}
        >
          <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
          <small className="fn12 mt-1">{t("ذخیره")}</small>
        </div>
        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={() => ShowHideFunction("addPage")}
        >
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn12 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
    </>
  );
};

export { DeviceDetails };
